import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "33",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M20.665 10.707a4.667 4.667 0 1 1-9.333 0 4.667 4.667 0 0 1 9.333 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M25.999 10.706a3.333 3.333 0 1 1-6.667 0 3.333 3.333 0 0 1 6.667 0M6.001 10.706a3.333 3.333 0 1 0 6.667 0 3.333 3.333 0 0 0-6.667 0",
      opacity: ".4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M24 22.707c0 2.577-3.582 4.666-8 4.666s-8-2.089-8-4.666 3.582-4.667 8-4.667 8 2.09 8 4.667"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M29.335 22.706c0 1.841-2.388 3.334-5.334 3.334s-5.333-1.493-5.333-3.334 2.388-3.333 5.333-3.333 5.334 1.492 5.334 3.333M2.665 22.706c0 1.841 2.388 3.334 5.334 3.334s5.333-1.493 5.333-3.334-2.388-3.333-5.333-3.333-5.334 1.492-5.334 3.333",
      opacity: ".4"
    }, null, -1)
  ])))
}
export default { render: render }